import { createAsyncThunk } from "@reduxjs/toolkit"

import { API } from "redux/api"

export const fetchManager = createAsyncThunk(
  "client/manager/fetch",
  async () => {
    const response = await API.get("/client/manager")
    return response.data
  },
)
